import { Button, Form, Input, Modal, Select, Typography } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import React from 'react';
import './CreateModalDevice.scss';

interface CreateModalProps {
  open: boolean;
  onCancel: () => void;
  handleSubmit: (name: string, type: string) => Promise<void>;
}

const CreateModalDevice = (props: CreateModalProps) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await props.handleSubmit(values.name, values.type);
      form.resetFields();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  };
  return (
    <Modal
      open={props.open}
      onOk={handleOk}
      onCancel={props.onCancel}
      footer={[
        <Button key="back" onClick={props.onCancel}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk}>
          Crear
        </Button>,
      ]}
    >
      <div className={'CreateModal__container'}>
        <div className={'CreateModal__titleContainer'}>
          <PlusCircleOutlined className={'CreateModal__icon'} />
          <Typography.Title level={3} className={'CreateModal__title'}>
            Crear nuevo dispositivo
          </Typography.Title>
        </div>
        <Form name="deviceGroup" className={'Modal__form'} form={form} layout="vertical">
          <Form.Item name="name" label="Nombre" rules={[{ required: true, message:'Por favor introduzca un nombre' }]} className={'CreateModal__form__item'}>
            <Input type="text" placeholder={'Nombre'} />
          </Form.Item>
          <Form.Item name="type" label="Tipo" rules={[{ required: true, message:'Por favor selecione un tipo' }]} className={'CreateModal__form__item'}>
            <Select
              placeholder="Tipo de dispositivo"
              options={[
                {
                  value: 'iFoam Compact',
                  label: 'iFoam Compact',
                },
                {
                  value: 'iFoam Pro',
                  label: 'iFoam Pro',
                },
                {
                  value: 'Multipro',
                  label: 'Multipro',
                },
                {
                  value: 'iBrush',
                  label: 'iBrush',
                },
                {
                  value: 'Protub',
                  label: 'Protub',
                },
                {
                  value: 'Multibot',
                  label: 'Multibot',
                },
                {
                  value: 'Visiobot',
                  label: 'Visiobot',
                },
              ]}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default CreateModalDevice;
